import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { securitySettingsCacheKey } from "./constants";
import type { CompanySecuritySettingsPayload } from "./types";

export const getCompanySecuritySettings = reactQueryFetcherAdapter(
  securitySettingsCacheKey,
  async (signal, companyId: string): Promise<CompanySecuritySettingsPayload> => {
    return fetch(`/companies/${companyId}/security_settings`, "GET", undefined, { signal });
  }
);
